import { useMemo, useState } from "react";

import { useDeviceType } from "@app/hooks/useDeviceType";

export function useTooltip() {
  const [showTooltip, setShowTooltip] = useState(false);
  const { isMobile } = useDeviceType();

  const elementProps = useMemo(() => {
    if (!isMobile) {
      return {
        onMouseEnter: () => setShowTooltip(true),
        onMouseLeave: () => setShowTooltip(false),
        position: "relative"
      };
    }
    return {};
  }, [isMobile]);

  return { showTooltip, elementProps };
}
